import { render, staticRenderFns } from "./DistanceAccusationSpeed.vue?vue&type=template&id=bfed40c2&"
import script from "./DistanceAccusationSpeed.vue?vue&type=script&lang=js&"
export * from "./DistanceAccusationSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports